var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.mailingLists),function(firstLevelItem){return _c('div',{key:firstLevelItem.id,staticClass:"form__input form__input--checkbox form__input--checkbox--bold"},[_c('mailing-list-section',{attrs:{"item":firstLevelItem,"data":_vm.data},on:{"change":_vm.handleChange}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570dad9e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MailingListsColumn.vue
// module id = 154
// module chunks = 0